// @flow
import * as React from 'react';
import { Select } from 'components';
import format from 'date-fns/format';
import AsyncValue, { type AsyncValueType } from 'lib/async-value';
import './UgcAssignment.css';
import type { ClientUserProfileRecord } from './types';

type AssignmentProps = {
  assignedToName?: ?string,
  assignedToId?: ?number,
  assignedByName?: ?string,
  assignedAt?: Date,
  options?: ?Array<ClientUserProfileRecord>,
  onChange: (?number) => *,
  changeStatus: ?AsyncValueType<>,
};

const Notice = ({ children }: { children: React.Node }) => (
  <span className="gray tc f6 ma2 mr0">{children}</span>
);

export default function UgcAssignment(props: AssignmentProps) {
  const {
    assignedToName,
    assignedToId,
    assignedByName,
    assignedAt,
    options,
    onChange,
    changeStatus,
  } = props;

  const optionsAreAvailable = Array.isArray(options) && options.length;

  if (changeStatus instanceof Error) {
    return <Notice>Error updating assignment.</Notice>;
  }

  if (!optionsAreAvailable) {
    return <Notice>No team members were found.</Notice>;
  }

  if (
    Array.isArray(options) &&
    options.length &&
    (assignedToName == null || assignedToId == null)
  ) {
    return (
      <div data-translate="false">
        <Select
          name="assignment"
          placeholder="Select a team member..."
          options={options}
          valueKey="profile_id"
          labelKey="name"
          value={assignedToId}
          // $FlowIssue
          onChange={(v: ClientUserProfileRecord) => {
            onChange(v.profile_id);
          }}
          multi={false}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center justify-between">
      <div className="bg-moon-gray mid-gray pv1 pl2 dib f6 br1 mr2 inline-flex items-center">
        <span className="lh-solid">{assignedToName}</span>
        <button
          type="button"
          className="button-reset bg-transparent b--none ml1 inline-flex gray hover-dark-gray UgcAssignment__removeButton"
          onClick={() => onChange(null)}
        >
          <svg
            viewBox="0 0 12 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              width: 10,
              height: 10,
            }}
          >
            <line
              x1="1"
              y1="11"
              x2="11"
              y2="1"
              stroke="currentColor"
              strokeWidth="2"
            />
            <line
              x1="1"
              y1="1"
              x2="11"
              y2="11"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        </button>
      </div>
      {changeStatus === AsyncValue.Pending ? (
        <Notice>Saving...</Notice>
      ) : (
        (assignedByName || assignedAt) && (
          <small className="gray dib lh-solid ma2 mr0">
            {assignedByName} {assignedAt && format(assignedAt, 'M/D/YY')}
          </small>
        )
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/client/UgcAssignment.js